import {LockPhonePage} from './LockPhonePage';
export default LockPhonePage;